import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { Tabs } from '@delmonicos/shared-design-system-react/src/components/tab/tabs.component';
import {
  extractTabKeys,
  useTabQuery,
} from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/hooks';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { InformationTabComponent } from './tabs/information-tab/information-tab.component';
import * as css from './ticket-details.module.scss';

enum TabsEnum {
  INFORMATION = 'information-tab',
}

export const TicketDetailsView = (): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // TABS //////////////////////////////////////////////////////////////////////

  const tabs = useMemo(
    () =>
      [
        {
          title: t('$.ticket-details.tab-information'),
          icon: 'clipboard',
          key: TabsEnum.INFORMATION,
        },
      ] as const,
    [t],
  );

  const { tab, setTab } = useTabQuery(
    TabsEnum.INFORMATION,
    extractTabKeys(tabs),
  );

  const renderTab = () => {
    switch (tab) {
      case TabsEnum.INFORMATION:
        return <InformationTabComponent />;
      default:
        return <div />;
    }
  };

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Stack
      direction="column"
      gap={GapEnum.XL}
      className={css.ticketDetailsContainer}>
      {tabs.length > 1 && (
        <Tabs currentTab={tab} elements={tabs} onTabClick={setTab} />
      )}
      {renderTab()}
    </Stack>
  );
};
